import { css, keyframes } from 'goober';
import React, { useState } from 'react';
import { fontBase } from '../../styles/font';
const Icon = css `
  position: relative;
`;
const MoveUp = keyframes `
  0% {
    transform: translateY(0);
    opacity: 0;
  }

  40%, 50%, 60% {
    transform: translateY(-70px);
    opacity: 1;
  }

  100% {
    transform: translateY(-100px);
    opacity: 0;
  }
`;
const MiniIcon = (popupEmoji) => css `
  position: absolute;
  width: 100%;
  font-size: ${30 / fontBase}rem;
  text-align: center;
  animation-name: ${MoveUp};
  animation-duration: 1000ms;
  animation-timing-function: ease-in-out;
  display: ${popupEmoji ? 'flex' : 'none'};
  justify-content: center;
`;
const scale = keyframes `
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
`;
const ScaleAnimation = css `
  animation-name: ${scale};
  animation-duration: 500ms;
  animation-timing-function: ease-in-out;
`;
const IconAnimation = (props) => {
    const { icon, animateicon, onClick } = props;
    const [scale, setScale] = useState(false);
    const [popupEmoji, setPopupEmoji] = useState(false);
    const handleAnimationEnd = () => {
        setScale(false);
        setPopupEmoji(true);
    };
    const handleMiniEmojiAnimation = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setPopupEmoji(false);
    };
    const handleClick = () => {
        setScale(true);
        onClick();
    };
    const klass = `${Icon} ${scale ? ScaleAnimation : ''}`;
    return (React.createElement("div", { className: klass, onClick: handleClick, onAnimationEnd: handleAnimationEnd },
        React.createElement("div", { className: MiniIcon(popupEmoji), onAnimationEnd: handleMiniEmojiAnimation }, animateicon),
        icon));
};
export default IconAnimation;
//# sourceMappingURL=index.js.map